<template>
  <div class="table-responsive">
    <table class="table table-bordered c-table c-table-color">
      <thead>
      <tr class="sticky-header">
        <th v-for="(header, headerIndex) in headers" :key="headerIndex">{{ header }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
        <td class="ltr" v-for="(col, colIndex) in row" :key="colIndex">{{ col }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.table-responsive {
  border: 1px solid #ccc;
  margin: 0 auto;
}

.ltr {
  direction: ltr;
}
</style>
